function searchShops(q) {
    $.ajax({
        url: "/search/shops",
        method: "GET",
        data: {
            q: q
        },
        success: function (data) {
            $('.search-results').html("");
            if (data.length > 0) {
                data.forEach(function(item){
                    $('.search-results').append('\
                    <div class="feed-item thumbnail clearfix" data-element-id="'+item["id"]+'">\
                        <img src="'+item["image"]+'" alt="">\
                        <a href="'+item["url"]+'" target="_blank">'+item["name"]+'</a>\
                        <div class="add-btn btn btn-success glyphicon glyphicon-plus" onclick="addElement($(this))"></div>\
                    </div>\
                    ');
                });
            } else {
                $('.search-results').html("По вашему запросу ничего не найдено");
            }
        }
    });
}

function searchProducts(q, shopId) {
    var url = '/search/products';
    if (shopId) {
        url += "/" + shopId;
    }
    $.ajax({
        url: url,
        method: "GET",
        data: {
            q: q
        },
        success: function (data) {
            console.log(data)
            $('.search-results').html("");
            if (data.length > 0) {
                data.forEach(function(item){
                    $('.search-results').append('\
                    <div class="feed-item thumbnail clearfix" data-element-id="'+item["id"]+'">\
                        <img src="'+item["image"]+'" alt="">\
                        <a href="'+item["url"]+'" target="_blank">'+item["name"]+'</a>\
                        <div class="add-btn btn btn-success glyphicon glyphicon-plus" onclick="addElement($(this))"></div>\
                    </div>\
                    ');
                });
            } else {
                $('.search-results').html("По вашему запросу ничего не найдено");
            }
        }
    });
}


function searchStocks(q) {
    $.ajax({
        url: "/search/stocks",
        method: "GET",
        data: {
            q: q
        },
        success: function (data) {
            $('.search-results').html("");
            if (data.length > 0) {
                data.forEach(function(item){
                    $('.search-results').append('\
                    <div class="feed-item thumbnail clearfix" data-element-id="'+item["id"]+'">\
                        <img src="'+item["image"]+'" alt="">\
                        <a href="'+item["url"]+'" target="_blank">'+item["name"]+'</a>\
                        <div class="add-btn btn btn-success glyphicon glyphicon-plus" onclick="addElement($(this))"></div>\
                    </div>\
                    ');
                });
            } else {
                $('.search-results').html("По вашему запросу ничего не найдено");
            }
        }
    });
}
function searchBanners(q) {
    $.ajax({
        url: "/search/advertisements",
        method: "GET",
        data: {
            q: q
        },
        success: function (data) {
            $('.search-results').html("");
            if (data.length > 0) {
                data.forEach(function(item){
                    $('.search-results').append('\
                    <div class="feed-item thumbnail clearfix" data-element-id="'+item["id"]+'">\
                        <img src="'+item["image"]+'" alt="">\
                        <a href="'+item["url"]+'" target="_blank">'+item["name"]+'</a>\
                        <div class="add-btn btn btn-success glyphicon glyphicon-plus" onclick="addElement($(this))"></div>\
                    </div>\
                    ');
                });
            } else {
                $('.search-results').html("По вашему запросу ничего не найдено");
            }
        }
    });
}
function searchCategories(q) {
    $.ajax({
        url: "/search/categories",
        method: "GET",
        data: {
            q: q
        },
        success: function (data) {
            $('.search-results').html("");
            if (data.length > 0) {
                data.forEach(function(item){
                    $('.search-results').append('\
                    <div class="feed-item thumbnail clearfix" data-element-id="'+item["id"]+'">\
                        <a href="'+item["url"]+'" target="_blank">'+item["name"]+'</a>\
                        <div class="add-btn btn btn-success glyphicon glyphicon-plus" onclick="addElement($(this))"></div>\
                    </div>\
                    ');
                });
            } else {
                $('.search-results').html("По вашему запросу ничего не найдено");
            }
        }
    });
}
